import type { EdgeRef } from '../editor/connectionMutations.js';
import { edgeIntersectsCut } from './edgeMath.js';

interface Point {
  x: number;
  y: number;
}

export interface CutConnectionsDeps {
  getEdges: () => EdgeRef[];
  getDotWorldPos: (nodeId: string, portIdx: number, isOut: boolean) => Point;
  cutEdgesWithHistory: (edges: EdgeRef[]) => number;
  renderGraph: () => void;
  scheduleRender: () => void;
}

export function createCutConnections(deps: CutConnectionsDeps): {
  severEdgesIntersectingLine(start: Point, end: Point): number;
} {
  return {
    severEdgesIntersectingLine(start, end) {
      const removedEdges = deps.getEdges().filter(edge => {
        const from = deps.getDotWorldPos(edge.fromNode, edge.fromPort, true);
        const to = deps.getDotWorldPos(edge.toNode, edge.toPort, false);
        return edgeIntersectsCut(from, to, start, end);
      });
      const removed = deps.cutEdgesWithHistory(removedEdges);
      if (removed === 0) return 0;
      deps.renderGraph();
      deps.scheduleRender();
      return removed;
    },
  };
}
